import { Canvas } from "@react-three/fiber";
import AnimateCamera from "./AnimateCamera";
import { useCanvasStore } from "@state/canvasStore";
import styled from "styled-components";
import { handleContextLoss } from "./utils/context";
import { useLocation } from "react-router-dom";

import { Vector3 } from "three";
import React, { useCallback, useRef } from "react";
import { useStore } from "@state/store";
import Capture from "./Capture";

import TheLocation from "./TheLocation";
import Residences from "./Residences";
import Popup from "./Popup";

export const initCam = {
  position: new Vector3(0.6, 0.6, -0.65),
  target: new Vector3(0, 0.6, 0),
  fov: 75,
  near: 0.005,
  far: 300,
};

export const controlsSettings = {
  location: {
    rotateSpeed: 0.2,
    enableZoom: true,
    enablePan: false,
    minPolarAngle: 0,
    maxPolarAngle: 1.2,
  },
  residences: {
    rotateSpeed: 0.2,
    enableZoom: true,
    enablePan: false,
    minPolarAngle: 0,
    maxPolarAngle: 1.2,
    maxDistance: 2,
    minDistance: 0.5,
  },
};

export const TCanvas = () => {
  const recordMode = true;

  const splatDataOnLoad = (e) => {
    console.log(e);
  };

  const canvasWrapperRef = useRef<HTMLDivElement>(null);
  const pathname = useLocation().pathname;

  const selectedUnit = useStore((s) => s.selectedUnit);
  const filteredUnits = useStore((s) => s.filteredUnits);
  const syncState = useStore((s) => s.syncState);

  const handleClickMesh = (unit: any) => {
    if (selectedUnit?.[0]?.unitName === unit.unitName) {
      syncState({ selectedUnit: [], controlsVisible: true });
    } else {
      syncState({ selectedUnit: [unit], controlsVisible: false });
    }
  };

  const centerRef = useRef(new Vector3(0, 0, 0));

  const [center, setCenter] = React.useState(centerRef.current);
  const onSelectedUnitChange = useCallback((unit) => {
    setCenter(unit.center);
  }, []);

  ////////////////////////////////

  const renderCanvasOn = ["/residences", "/the-location"];

  return (
    <CanvasWrapper
      style={{
        zIndex: renderCanvasOn.includes(pathname) ? 4 : -1,
        opacity: renderCanvasOn.includes(pathname) ? 1 : 0,
        // display: renderCanvasOn.includes(pathname) ? "block" : "none",
        pointerEvents: renderCanvasOn.includes(pathname) ? "auto" : "none",
        left: pathname === "/residences" ? "25%" : "0%",
        width: pathname === "/residences" ? "75%" : "100%",
      }}
      ref={canvasWrapperRef}
    >
      <Popup active={selectedUnit?.[0]} />
      <Canvas
        // frameloop="demand"
        gl={{ preserveDrawingBuffer: recordMode ? true : false }}
        style={{
          opacity: 1,
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
        dpr={recordMode ? 2 : 1.25}
      >
        {/* <axesHelper args={[10]} /> */}
        <Capture />
        {
          /* <AnimateCamera
          controlsSettings={controlsSettings}
          initCam={initCam}
          pathname={pathname}
        /> */
        }

        <group position={[0.12, 0, -0.6]}>
          <Residences
            recordMode={recordMode}
            splatDataOnLoad={splatDataOnLoad}
            center={center}
            pathname={pathname}
            selectedUnit={selectedUnit}
            filteredUnits={filteredUnits}
            onSelectedUnitChange={onSelectedUnitChange}
            handleClickMesh={handleClickMesh}
          />
          <TheLocation
            recordMode={recordMode}
            splatDataOnLoad={splatDataOnLoad}
          />
        </group>
      </Canvas>
    </CanvasWrapper>
  );
};

const CanvasWrapper = styled.div`
  z-index: 4;
  position: absolute;
  top: 0;

  height: 100%;
  img {
    opacity: 1;
    z-index: 10;
    position: absolute;
    pointer-events: none;
    user-select: none;
    width: 100%;
    height: 100%;

    object-fit: cover;
    object-position: center;
  }
`;

export default TCanvas;
// const canvasReady = use
